/**
 * Asynchronously loads the component for Header
 */

import { lazyLoad } from 'utils/loadable';

export const DynamicComponents = lazyLoad(
  () => import('./index'),
  module => module.DynamicComponents,
);
